<template lang="pug">
  vm-prompt(@vm-cancel="close" vm-buttons-hidden @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!$v.newRecord.$invalid" :vm-active="isModalCommissionsVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=11)
        b-form-group
          vm-input(:placeholder='$t("commissions.commission_placeholder")' v-model="newRecord.commission" :label='$t("commissions.commission")')
      vm-col(vm-justify="left", vm-align="left", vm-w=1)
          vm-button(size="small" icon="plus" @click="saveRecord" :disabled="!newRecord.commission")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        vm-table(:data="newRecord.commissions")
          template(slot="thead")
            vm-th
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr,indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot {{data[indextr][column]}}

</template>

<script>
// import { required, minLength, email } from 'vuelidate/lib/validators' // Ver documentacion
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalCommissionConfig',
  props: {
    newRecord: {
      default: () => {},
      type: Object
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({
    priority: [
      {
        text: 'Normal',
        value: 1,
        color: 'warning'
      },
      {
        text: 'Urgente',
        value: 2,
        color: 'primary'
      }
    ],
    columns: [
      // Agrega las columnas a mostrar
      'commission'
    ]
  }),
  validations: {
    newRecord: {
      // contact: {
      //   required,
      //   minLength: minLength(5)
      // },
      // email: {
      //   required,
      //   email
      // }
    }
  },
  computed: {
    ...mapGetters([
      'isModalCommissionsVisible',
      'commissions'
    ]),
    getTitle () {
      return 'Comisiones'
    }
  },
  watch: {
    'commissions' (commissions) {
      this.newRecord.commissions.unshift({ ...commissions })
      // console.log(this.newRecord, commissions)
    }
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addCommission',
      'editCommission',
      'deleteCommission',
      'setModalCommissionsVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      // console.log(this.newRecord)
      this.addCommission(this.newRecord)
    },
    async deleteCommissionConfirm (commission) {
      let t = this
      this.auxDeleteCommission = () => {
        t.deleteCommission(commission)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(commission.id) }),
        accept: this.auxDeleteCommission
      })
    },
    async getCatalog () {
      Object.keys(this.commissionsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let columns = value.target.parentElement.parentElement.getAttribute('columns')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?param=${param},${columns}`
      this.loadCatalog(payload)
    },
    close () {
      this.setModalCommissionsVisible(false)
    }
  }
}
</script>

<style lang="scss">
  .vm-table--tbody-table {
    min-width: 0 !important;
  }
  .vm-table--header {
    padding: 0 !important;
  }
</style>
